import $ from 'jquery';
import { utils } from 'tc-helpers';

function cleanField(str = '') {
  return str
    .replace(/(\r\n|\n|\r)/gm, '')
    .replace(/\s+/g, '_')
    .toLowerCase();
}

function pushGA4Event({ eventName, eventData }) {
  if (typeof dataLayer != 'undefined') {
    dataLayer.push({
      event: eventName,
      eventData: {
        event_source: 'gaEvent',
        ...eventData
      }
    });
  }
}

function pushEvent(e, optional = {}) {
  if (typeof dataLayer != 'undefined') {
    let push = {
      event: 'GAEvent',
      eventCategory: e.category,
      eventAction: e.action,
      eventLabel: e.label
    };
    dataLayer.push(Object.assign(push, optional));
  }
}

function pushEventNonInteraction(e) {
  if (typeof dataLayer != 'undefined') {
    dataLayer.push({
      event: 'GAEventNonInteraction',
      eventCategory: e.category,
      eventAction: e.action,
      eventLabel: e.label
    });
  }
}

function pushInformation(variable_name, variable_value) {
  var info = {};
  info[variable_name] = variable_value;
  if (typeof dataLayer != 'undefined') {
    dataLayer.push(info);
  }
}


function getFullUrl() {
  return decodeURIComponent(document.location.href).replace(/([a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/, '');
}

function getHeaderName() {
  if (!$('[data-header-name]').length) {
    return '';
  }
  return $('[data-header-name]').data('header-name');
}

function getFooterName() {
  if (!$('[data-footer-name]').length) {
    return '';
  }
  return $('[data-footer-name]').data('footer-name');
}

function getThemeName() {
  if (!$('[data-theme-name]').length) {
    return '';
  }
  return $('[data-theme-name]').data('theme-name');
}

function getBMType() {
  let BMtype = 'bm';
  if (typeof bm_ui_settings != 'undefined') {
    let layout = bm_ui_settings.layout;
    let position = bm_ui_settings.position;
    let calendars = bm_ui_settings.calendars;

    if (layout === 'vertical' && bm_ui_settings.collapsed === 'collapsed') {
      BMtype += 'co';
    } else {
      BMtype += layout === 'vertical' ? 'vt' : 'ho';
      BMtype += calendars.isLargeLayout ? '2' : '1';
      BMtype += layout === 'vertical' ? '-' + position : '';
    }
  }
  return BMtype;
}



function calculateElementPosition(element) {
  const positionLookAtTable = {
    horizontal: {
      left: 3.334, //30
      center: 1.4285, //70
      right: 1 //100
    },
    vertical: {
      top: 3.334, //30
      middle: 1.4285, //70
      bottom: 1 //100
    }
  };

  let position = {};
  let verticalRatio = window.innerHeight / (element.offset().top - $(window).scrollTop());
  let horizontalRatio = window.innerWidth / element.offset().left;
  if (verticalRatio < positionLookAtTable.vertical.middle) {
    position.vertical = 'bottom';
  } else if (verticalRatio > positionLookAtTable.vertical.middle && verticalRatio < positionLookAtTable.vertical.top) {
    position.vertical = 'middle';
  } else {
    position.vertical = 'top';
  }
  if (horizontalRatio < positionLookAtTable.horizontal.center) {
    position.horizontal = 'right';
  } else if (
    horizontalRatio > positionLookAtTable.horizontal.center &&
    horizontalRatio < positionLookAtTable.horizontal.left
  ) {
    position.horizontal = 'center';
  } else {
    position.horizontal = 'left';
  }
  return position.vertical + '-' + position.horizontal;
}

/**
 * Given an URL and a parameter the function will return the value for the
 * parameter if exists.
 * @param {String} link
 * @param {String} parameter
 * @returns String (parameter value)
 */
function getURLParameter(link, parameter) {
  let params = new URL(link.toLowerCase()).searchParams;
  return params.get(parameter.toLowerCase());
}

/**
 * Fires a custom event
 * @param {String} eventName The name of the event
 * @param {Object} eventData Additional data pushed for listeners
 * @param {Element} source Element that will fire the event. Defaults to document.
 * @void
 */
function fireEvent(eventName, eventData = {}, source = null) {
  utils.fireEvent(eventName, eventData, source);
}

/**
 * Checks if TC extension integrated datalayer is enabled
 * (tc-ext-integrated-datalayer)
 * @returns boolean
 */
function checkIntegratedDatalayerEnabled() {
  if (!window.GLXExtensions) return false;
  if (!window.GLXExtensions.tcIntegratedDataLayer) return false;
  if (!window.GLXExtensions.tcIntegratedDataLayer.isEnabled) return false;

  return window.GLXExtensions.tcIntegratedDataLayer.isEnabled;
}

function  getPossibleProductIDFromBookingLink(bookingLink) {
  const params = [
    { key: 'rateplanid', idPrefix: 'rateplanid=', label: 'offer' },
    { key: 'advertisementid', idPrefix: 'advertisementid=', label: 'offer' },
    { key: 'roomtypeid', idPrefix: 'roomid=', label: 'room' },
    { key: 'prodid', idPrefix: 'prodid=', label: 'package' }
  ];

  for (const { key, label, idPrefix } of params) {
    const value = getURLParameter(bookingLink, key);
    if (value) {
      return { label, product_id: `${idPrefix}${value}` };
    }
  }

  return false;
}

export {
  cleanField,
  pushGA4Event,
  pushEvent,
  pushEventNonInteraction,
  pushInformation,
  calculateElementPosition,
  getFullUrl,
  getFooterName,
  getHeaderName,
  getThemeName,
  getBMType,
  getURLParameter,
  fireEvent,
  checkIntegratedDatalayerEnabled,
  getPossibleProductIDFromBookingLink
};
